<template>
  <div class="row">
    <div class="col s12 z-depth-2" style="background-color: white; height: 100vh" v-if="activeOrganisation">
      <div class="row">
        <div class="col s12">
          <p style="display: inline-block; margin-bottom: 0px" @click="$router.go(-1)" class="clickable"><u>organisations</u></p><p style="display: inline-block; margin-bottom: 0px">&nbsp;/ editorganisation</p>
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <div class="divider"></div>
          <div class="section">
            <h5>Edit organisation {{ activeOrganisation.name }}</h5>
            <p style="margin-bottom: 0px">POSS Online</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div>
          <a style="min-width: 150px; margin-right: 12px; margin-left: 12px" class="waves-effect waves-light btn" @click="saveOrganisation()">Save<i class="material-icons right">save</i></a>
          <a style="min-width: 150px; margin-right: 12px" class="waves-effect waves-light btn" @click="$router.go(-1)">Cancel<i class="material-icons right">cancel</i></a>
          <a style="min-width: 150px" class="waves-effect waves-light btn" @click="removeOrganisation()">Delete<i class="material-icons right">delete</i></a>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <div class="divider"></div>
          <ul class="tabs">
            <li class="tab col s2"><a class="clickable" @click="activeTab = 'General'">General</a></li>
          </ul>
        </div>
      </div>

      <div class="row" v-show="activeTab === 'General'">
        <div class="col s4">
          <div class="row">
            <div class="col s3">
              <p style="margin-top: 12px">name</p>
            </div>
            <div class="col s6">
              <div class="input-field no-margin">
                <input v-model="activeOrganisation.name" type="text" style="margin-bottom: 0px">
              </div>
            </div>
          </div>
        </div>
        <div class="col s6">
          <!-- departments can be loaded here if tabs is to much of an issue -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import organisationsService from '@/services/api/OrganisationsApi'

export default {
  data: function () {
    return {
      activeTab: 'General',
      activeOrganisation: undefined
    }
  },
  mounted: function () {
    this.activeOrganisation = this.$route.params.organisation
  },
  updated: function () {
    // Initialize select boxes
    M.FormSelect.init(document.querySelectorAll('select'))
    M.Tabs.init(document.querySelectorAll('tabs'))
  },
  methods: {
    saveOrganisation: function () {
      organisationsService.editOrganisation(this.activeOrganisation).then(result => {
        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'Save organisation',
          text: 'Organisation saved'
        })
      }).catch(e => {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Saving organisation failed',
          text: 'Unknown error occured'
        })
      })
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 24px;
  margin-bottom: 24px;
}

.inline-icon {
   vertical-align: bottom;
}

/* BUTTON */
.btn-floating:hover {
  background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #F39810;
}

.btn, .btn-large, .btn-small {
  background-color: #56CCF2;
}
</style>



// WEBPACK FOOTER //
// src/pages/organisations/Organisation.vue